import { NavLink } from "react-router";
import BlocsList from "../../components/Blocs/BlocsList";
import { useTrads } from "../../contexts/trads/useTrads";

function Blocs(){
  const {translate}=useTrads();
  return (
  <div>
    <nav>
        <NavLink to={`/blocs/add`} className="btn btn-primary mt-3">{translate('btn_add')}</NavLink>
    </nav>
    <BlocsList   />
  </div>
  );
}
export default Blocs;